import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { IOptionsResponse } from '../../../common/common.types'
import {
  setNeuroFacialOptions,
  setNeuroGazeOptions,
  setNeuroLimbOptions,
  setNeuroMotorOptions,
  setNeuroSpeechOptions,
} from '../store/options.actions'
import { OptionsService } from '../services/options.service'

export function* getNeuroOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getAssessmentNeuroOptions])
    const { entity } = response

    const motorOptions = entity.filter((opt) => opt.field === 'motor')
    const speechOptions = entity.filter((opt) => opt.field === 'speech')
    const gazeOptions = entity.filter((opt) => opt.field === 'gaze')
    const facialOptions = entity.filter((opt) => opt.field === 'facial')
    const limbOptions = entity.filter((opt) => opt.field === 'limb')

    yield put(setNeuroMotorOptions(motorOptions))
    yield put(setNeuroSpeechOptions(speechOptions))
    yield put(setNeuroGazeOptions(gazeOptions))
    yield put(setNeuroFacialOptions(facialOptions))
    yield put(setNeuroLimbOptions(limbOptions))
  } catch (e) {
    yield put(throwPcrException(`getNeuroOptions() error: ${e}`))
  }
}

export function* getNeuroOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getNeuroOptions)
}
